module.exports = __webpack_public_path__ + "img/tnbox_logo.be1fc59b.png";